// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const classnames = require('classnames');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { FormattedText } = require('core/i18n').i18n;

// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { ConsentChange } = require('components/myProfile/consentChange/consentChange');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');

// @actions
const consentsActions = require('actions/consentsProfile');
const consentsProfileActions = require('actions/gdprConsents');
const okConsentsActions = require('gdpr-consents/actions/OKConsents.js');

// @ constants
const { OKCONSENTS_NEGATIVE_VALUE, OKCONSENTS_CONSENTS_SWITCH } = require('constants/consents');

const { buildLastStepInformation, getStateGdprConsent } = require('utilities/consentsHelper');

class MyProfileConsentView extends React.Component {
    constructor(props) {
        super(props);

        this.updateConsentsProfile = this.updateConsentsProfile.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.buildErrorGdpr = this.buildErrorGdpr.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.lastStep = this.lastStep.bind(this);
    }

    componentWillUnmount() {
        const { consentsActions, okConsentsActions } = this.props;
        consentsActions.resetConsentsProfile();
        okConsentsActions.reset();
    }

    updateConsentsProfile() {
        const { consentsActions } = this.props;
        consentsActions.updateConsentsProfile();
    }

    nextStep() {
        const { consentsActions } = this.props;
        consentsActions.nextStep();
    }

    lastStep() {
        const { consentsActions } = this.props;
        consentsActions.lastStep();
    }

    buildErrorGdpr() {
        const errorTitle = formatText('consents-errorTitleWizard');
        const errorMessage = formatText('consents-errorMessageWizard');
        const goBackButtonLabel = formatText('consents-goBackButton').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/edit'
        }
        return (
            <div className="row grid-view--content-position-negative">
                <WizardError
                    errorMessage={errorTitle}
                    errorSubMessage={errorMessage}
                    mainButton={goBackButton}
                />
            </div>
        );
    }

    buildBreadCrumb() {
      return [
          {
              text: formatText('breadcrumb-personalInformation'),
              url: '/myprofile/edit'
          },
          {
              text: formatText('breadcrumb-modifyConsents'),
              url: ''
          }
      ]
    }

    buildSuccessful() {
        const { immConsentsGdpr } = this.props;
        const goBackButton = {
            label: <FormattedText value="consents-goBackButton" />,
            url: '/myprofile/edit'
        };
        const onlyConsents = immConsentsGdpr.get('consents').filter((consents) => consents.getIn(['consentCell', 'displayType']) === OKCONSENTS_CONSENTS_SWITCH);
        let consentsBuild = onlyConsents.toJS().map((consent, index) => {
            const status = getStateGdprConsent(consent.status);
            const moreElementClass = classnames('col-xs-12 content-no-padding', {
                'consent-change-info__margin-top-consent': index >= 1,
            });

            let consentSummary;

            if (consent.status === OKCONSENTS_NEGATIVE_VALUE && !!consent.channels && consent.channels.length > 0) {
                consentSummary = buildLastStepInformation(immConsentsGdpr.getIn(['consents', index]));
            } else {
                consentSummary = <FormattedText value={status} />;
            }

            return(
                <div className={moreElementClass}key={index.toString()}>
                    <p>
                        <strong>
                            <FormattedText value={consent.consentCell.poEditorTitle} />
                        </strong>
                    </p>
                    <p>
                        {consentSummary}
                    </p>
                </div>
            )
        });

        return (
            <div className="row grid-view--content-position-negative">
                <WizardSuccess
                    successMessage={formatText('consents-successStepTitle')}
                    mainButton={goBackButton}
                >
                    <div className="row">
                        {consentsBuild}
                    </div>
                </WizardSuccess>
            </div>
        );
    }

    render() {
        const { immConsentsProfile, immConsentsGdpr, okConsentsActions } = this.props;
        const boxBody = ['consents-boxBody1'];
        const mappingBreadcrumb = this.buildBreadCrumb();
        const success = immConsentsProfile.get('success');
        const errorGDPR = immConsentsProfile.get('errorGDPR');
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('consents-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {!success && !errorGDPR && <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <ConsentChange
                                            immConsentsProfile={immConsentsProfile}
                                            immConsentsGdpr={immConsentsGdpr}
                                            handleUpdateConsents={this.updateConsentsProfile}
                                            nextStep={this.nextStep}
                                            lastStep={this.lastStep}
                                            updateAllConsentsStatus={okConsentsActions.updateAllConsentsStatus}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox
                                            boxTitle={formatText('consents-boxTitle')}
                                            boxBody={boxBody}
                                        />
                                    </div>
                                    <div className="col-xs-12 grid-view--fix-cell-separation">
                                        <CallMeBack pageTitle={getFinalTitle('consents-titleHeader')} hasEntrance={false}/>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {success && !errorGDPR && this.buildSuccessful()}
                        {!success && errorGDPR && this.buildErrorGdpr()}
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileConsentView.propTypes = {
    immConsentsProfile: PropTypes.object,
    immConsentsGdpr: PropTypes.object,
    consentsProfileActions: PropTypes.object,
    consentsActions: PropTypes.object,
    okConsentsActions: PropTypes.object.isRequired
}

module.exports.constructor = MyProfileConsentView;

module.exports.MyProfileConsentView = connect(
    state => ({
        immConsentsProfile: state.consentsProfile,
        immConsentsGdpr: state.gdprConsents,
    }),
    dispatch => ({
        consentsActions: bindActionCreators(consentsActions, dispatch),
        consentsProfileActions: bindActionCreators(consentsProfileActions, dispatch),
        okConsentsActions: bindActionCreators(okConsentsActions, dispatch)
    })
)(MyProfileConsentView);
